const upsertMetaTag = (name, content) => {
  if (content === undefined) {
    return;
  }

  const existingTag = document.querySelector(`meta[name="${name}"]`);

  if (content === null || content === "") {
    if (existingTag) {
      existingTag.remove();
    }
    return;
  }

  const tag = existingTag || document.createElement("meta");
  tag.setAttribute("name", name);
  tag.setAttribute("content", content);

  if (!existingTag) {
    document.head.appendChild(tag);
  }
};

export const setPageMeta = ({ title, description, keywords, robots } = {}) => {
  if (title !== undefined) {
    document.title = title || "";
  }

  upsertMetaTag("description", description);
  upsertMetaTag("keywords", keywords);
  upsertMetaTag("robots", robots);
};
